import _ from "lodash";
require("es6-promise").polyfill();
import fetch from "isomorphic-fetch";
let instance = null;

export default class HttpClient {
  constructor() {
    if (!instance) instance = this;
    return instance;
  }

  initialize = (history, userStore) => {
    this.history = history;
    this.userStore = userStore;
  };

  put = (url, body) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body),
      cache: "no-cache"
    };
    let data = {};
    return fetch(url, init)
      .then(response => {
        data = { status: response.status, headers: response.headers };
        if (response.status === 401) this.handleUnAuthorized();
        return response.json();
      })
      .then(response => {
        let newResponse = _.assign(data, { body: response });
        if (!(data.status >= 200 && data.status < 300)) throw newResponse;
        return newResponse;
      });
  };

  post = (url, body) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
      cache: "no-cache"
    };
    let data = {};
    return fetch(url, init)
      .then(response => {
        data = { status: response.status, headers: response.headers };
        if (response.status === 401) this.handleUnAuthorized();
        return response.json();
      })
      .then(response => {
        let newResponse = _.assign(data, { body: response });
        if (!(data.status >= 200 && data.status < 300)) throw newResponse;
        return newResponse;
      });
  };

  get = url => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    let data = {};
    return fetch(url, init)
      .then(response => {
        data = { status: response.status, headers: response.headers };
        if (response.status === 401) this.handleUnAuthorized();
        return response.json();
      })
      .then(response => {
        let newResponse = _.assign(data, { body: response });
        if (!(data.status >= 200 && data.status < 300)) throw newResponse;
        return newResponse;
      });
  };

  delete = url => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "DELETE",
      headers: headers,
      cache: "no-cache"
    };
    let data = {};
    return fetch(url, init)
      .then(response => {
        data = { status: response.status, headers: response.headers };
        if (response.status === 401) this.handleUnAuthorized();
        return response.json();
      })
      .then(response => {
        let newResponse = _.assign(data, { body: response });
        if (!(data.status >= 200 && data.status < 300)) throw newResponse;
        return newResponse;
      });
  };

  multipart = (url, formData, method) => {
    let headers = new Headers();
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: method,
      headers: headers,
      cache: "no-cache",
      body: formData
    };
    let data = {};
    return fetch(url, init)
      .then(response => {
        data = { status: response.status, headers: response.headers };
        if (response.status === 401) this.handleUnAuthorized();
        return response.json();
      })
      .then(response => {
        let newResponse = _.assign(data, { body: response });
        if (!(data.status >= 200 && data.status < 300)) {
          throw newResponse;
        }

        return newResponse;
      })
      .catch(error => {
        // debugger
        let errorMsg = {error: error.body, status: error.status}
        return errorMsg;
      });
  };

  handleUnAuthorized = () => {
    this.userStore.setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    this.history.push("/newuser/signin");
  };
}



// WEBPACK FOOTER //
// ./src/services/HttpClient.js